var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ja"},[(_vm.job)?_c('b-main',{staticClass:"ja__button",attrs:{"type":"submit","title":_vm.buttonTitle,"active":!_vm.isDisableApply},on:{"click":_vm.onApply}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }